function Contains(target: any, pattern: any) {
  var value = 0
  pattern.forEach(function (word: any) {
    value = value + target.includes(word)
  })
  return value === 1
}

export default Contains
